import { render, staticRenderFns } from "./CreateStudent.vue?vue&type=template&id=4772bbe4&scoped=true&"
import script from "./CreateStudent.vue?vue&type=script&lang=js&"
export * from "./CreateStudent.vue?vue&type=script&lang=js&"
import style0 from "./CreateStudent.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CreateStudent.vue?vue&type=style&index=1&id=4772bbe4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4772bbe4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardActions,VCardText,VCol,VDataTable,VDialog,VIcon,VTextField})
